import { render, staticRenderFns } from "./add-room2.vue?vue&type=template&id=7921c408&scoped=true&"
import script from "./add-room2.js?vue&type=script&lang=js&"
export * from "./add-room2.js?vue&type=script&lang=js&"
import style0 from "./add-room2.css?vue&type=style&index=0&id=7921c408&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7921c408",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardText,VFlex,VLayout,VProgressLinear,VTextField})
